var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3719 1.49259C12.372 1.5911 12.3527 1.68866 12.315 1.77967C12.2773 1.87068 12.222 1.95334 12.1522 2.02291L7.15223 7.0229C7.01158 7.16354 6.82082 7.24255 6.62192 7.24255C6.42301 7.24255 6.23226 7.16354 6.0916 7.0229L1.0916 2.02291C0.952844 1.88187 0.875436 1.69171 0.876242 1.49386C0.877048 1.29601 0.956001 1.10649 1.09591 0.966583C1.23581 0.826679 1.42533 0.747725 1.62318 0.74692C1.82103 0.746114 2.01119 0.823522 2.15223 0.962282L6.62192 5.4319L11.0916 0.962282C11.1965 0.857399 11.3301 0.785975 11.4756 0.757039C11.6211 0.728103 11.7719 0.742955 11.9089 0.799717C12.046 0.85648 12.1631 0.952604 12.2455 1.07593C12.3279 1.19926 12.3719 1.34426 12.3719 1.49259Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav);
export default __webpack_public_path__ + "static/media/icon-nav.a26cb69c50f60bad28b7da97e6429c49.svg";
export { ForwardRef as ReactComponent };